import { AdditionalPaymentRequest } from '@/messaging/additionalPaymentRequestWebServices';
import { HubConnection } from '@microsoft/signalr';

export const configureAdditionalPaymentNotifications = (connection: HubConnection, vue: Vue) => {
    connection.on('PaymentRequestSaved', (request: AdditionalPaymentRequest) => {
        vue.$emit("PaymentRequestSaved", request);
    });
}